import PropTypes from "prop-types";
import { CustomContainer, Form, Col } from "../../DependencyHelper";
import DeliveryAddress from "../deliveryAddress/DeliveryAddress";
import formStyles from "../CheckoutForms.module.scss";
import styles from "./CompanyVat.module.scss";

const CompanyVat = ({
  formName,
  fieldValues,
  fieldErrors,
  fieldErrorsMessage,
  readOnlyValues,
  onChangeHandler,
  onBlurHandler,
  validations,
  stateTypesOptions,
  containerClassName,
}) => {
  const handleChange = (event) => {
    onChangeHandler(event, null, formName);
  };

  const handleBlur = (event) => {
    onBlurHandler(event, null, formName);
  };

  return (
    <CustomContainer
      className={`${formStyles["main-container"]} ${styles["main-container"]} ${containerClassName}`}
    >
      <Form.Row
        className={`${formStyles["main-row"]} ${styles["address-check-row"]}`}
      >
        <Form.Group
          as={Col}
          sm="12"
          md="12"
          className={formStyles["form-group"]}
          controlId={`validationFormcv101`}
        >
          <Form.Label
            className={formStyles["form-label"]}
            id={`validationFormcv101-label`}
          >
            Company name
          </Form.Label>
          <Form.Control
            type="text"
            name="companyVatName"
            value={fieldValues["companyVatName"]}
            placeholder="Add company name"
            onChange={handleChange}
            onBlur={handleBlur}
            readOnly={readOnlyValues["companyVatName"]}
            isInvalid={fieldErrors["companyVatName"]}
            className={
              fieldErrors["companyVatName"] ? formStyles["invalid"] : ""
            }
          />
          <Form.Control.Feedback
            type="invalid"
            className={formStyles["invalid-feedback"]}
          >
            {fieldErrorsMessage["companyVatName"]}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group
          as={Col}
          sm="12"
          md="12"
          className={`mb-0 ${formStyles["form-group"]}`}
          controlId={`validationFormcv102`}
        >
          <Form.Label
            className={formStyles["form-label"]}
            id={`validationFormcv102-label`}
          >
            Company VAT Number
          </Form.Label>
          <Form.Control
            type="text"
            name="companyVatNumber"
            value={fieldValues["companyVatNumber"]}
            placeholder="Add VAT number"
            onChange={handleChange}
            onBlur={handleBlur}
            readOnly={readOnlyValues["companyVatNumber"]}
            isInvalid={fieldErrors["companyVatNumber"]}
            className={
              fieldErrors["companyVatNumber"] ? formStyles["invalid"] : ""
            }
          />
          <Form.Control.Feedback
            type="invalid"
            className={formStyles["invalid-feedback"]}
          >
            {fieldErrorsMessage["companyVatNumber"]}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group
          as={Col}
          sm="12"
          md="12"
          className={`${formStyles["form-group"]} ${styles["address-check-form-group"]}`}
        >
          <Form.Check
            custom
            name="ciaddressCheck"
            label="The company's address is the same as the delivery address"
            checked={fieldValues["ciaddressCheck"]}
            onChange={handleChange}
            onBlur={handleBlur}
            className={formStyles["form-checkbox-label"]}
            id={`validationFormcv103`}
          />
        </Form.Group>
      </Form.Row>
      {!fieldValues["ciaddressCheck"] && (
        <DeliveryAddress
          formName={formName}
          validations={validations}
          fieldValues={fieldValues}
          fieldErrors={fieldErrors}
          fieldErrorsMessage={fieldErrorsMessage}
          readOnlyValues={readOnlyValues}
          stateTypesOptions={stateTypesOptions}
          onChangeHandler={onChangeHandler}
          onBlurHandler={onBlurHandler}
          containerClassName={styles["vat-address-container"]}
          rowClassName={styles["vat-address-row"]}
        ></DeliveryAddress>
      )}
      <Form.Row
        className={`${formStyles["main-row"]} ${styles["future-check-row"]}`}
      >
        <Form.Group
          as={Col}
          sm="12"
          md="12"
          className={formStyles["form-group"]}
        >
          <Form.Check
            custom
            name="cifutureCheck"
            label="Save this company's details for next time"
            checked={fieldValues["cifutureCheck"]}
            onChange={handleChange}
            onBlur={handleBlur}
            className={formStyles["form-checkbox-label"]}
            id={`validationFormcv104`}
          />
        </Form.Group>
      </Form.Row>
    </CustomContainer>
  );
};

CompanyVat.propTypes = {
  formName: PropTypes.string,
  fieldValues: PropTypes.object,
  fieldErrors: PropTypes.object,
  fieldErrorsMessage: PropTypes.object,
  readOnlyValues: PropTypes.object,
  onChangeHandler: PropTypes.func,
  validations: PropTypes.object,
  onBlurHandler: PropTypes.func,
};

CompanyVat.defaultProps = {
  formName: "companyInformation",
  fieldValues: {},
  fieldErrors: {},
  fieldErrorsMessage: {},
  readOnlyValues: {},
  validations: {},
};

export default CompanyVat;
